require('./bootstrap');

window.Vue = require('vue');

require('owl.carousel2');

// videojs
import videojs from 'video.js';
window.videojs = videojs;

// added by Yancey 2026-01-21
videojs.options.autoSetup = false;
videojs.options.crossOrigin = 'anonymous';

// hls plugin for videojs v7
// require('videojs-contrib-hls/es5/videojs-contrib-hls');

// require('videojs-resolution-switcher');
// require('@xiaoyexiang/videojs-resolution-switcher-v7/lib/videojs-resolution-switcher-v7');

require('element-ui');

window.acom = require('./acom');
// require('./AcomPlayer.js');

// import * as acom from './acom';
// window.acom = acom.default;


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
